import { render, staticRenderFns } from "./PopupSelectButton.vue?vue&type=template&id=a8b809e0&scoped=true&"
import script from "./PopupSelectButton.vue?vue&type=script&lang=ts&"
export * from "./PopupSelectButton.vue?vue&type=script&lang=ts&"
import style0 from "./PopupSelectButton.vue?vue&type=style&index=0&id=a8b809e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b809e0",
  null
  
)

export default component.exports